import AppStore from './AppStore';

const stores = {
  AppStore,
};

export default stores;
